// =============================================================================
// src/lib/queryClient.js - the one TanStack Query client for the app.
//
// Moved out of main.jsx (Oct 2026, round 4 #3) so plain modules can share the
// cache too: lib/shellCounts.js reads the Inbox counts through it, so the
// sidebar badge, the bell and the Inbox page subtitle are one read, and the
// staff shell's background counts are deduped across the components that ask.
//
// Conservative defaults so migrated hooks behave like the hand-rolled fetches
// they replace:
//  - staleTime 60s: a re-mount within a minute reuses the cached result
//    instead of refetching (removes the per-mount round trip).
//  - retry 1: one retry on transient failure, not the library default of 3.
//  - refetchOnWindowFocus off: PHI screens should not silently refetch on
//    tab focus; explicit refetch() stays the way to reload.
// AuthProvider calls queryClient.clear() on sign-out, so nothing cached here
// outlives the session on a shared workstation.
// =============================================================================
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
